// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"456c00eb","453":"0321bfd5","455":"fc479632","977":"eda608b0"}[chunkId] + ".chunk.js";
};